import React, { useEffect, useMemo, useState } from "react";
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Input,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from "classnames";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import usePersistStoreData from "../../Components/Hooks/usePersistStoreData";
import { useSelector } from "react-redux";
import { home_finance_ledgerThunk } from "../../slices/thunks";
import Home_Financial_Ledger_Skeleton from "../../Components/Skeleton/Home_Financial_Ledger_Skeleton";

const Home_financial_ledger = () => {
  // document.title = "Dashboard | B.N. Rathi";

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { userData } = usePersistStoreData();
  const token = userData?.token;
  const [selectedTime, setSelectedTime] = useState("current-fy");

  //handle investment summery filter
  const handleFilterTime = (event) => {
    const selectedValue = event.target.value;
    setSelectedTime(selectedValue);
    dispatch(
      home_finance_ledgerThunk({
        token,
        params: { data_range: selectedValue },
      })
    );
  };

  const { home_financeLedgerData, home_financeLedgerLoading } = useSelector(
    (state) => state.Home_Finance_Ledger
  );

  useEffect(() => {
    dispatch(
      home_finance_ledgerThunk({
        params: { data_range: selectedTime },
        token,
      })
    );
  }, []);

  

  return (
    <React.Fragment>
      <div className="my-2">
        {/* <div>
          <p className="mb-0 fs-14 fw-medium text-muted">
            <i className="me-1 ri-time-line align-middle fs-14"></i>
            Updated on{" "}
            <span className="text-primary">
              {home_financeLedgerData?.as_on_date}
            </span>
          </p>
        </div> */}

        <Row className="align-items-center">
          <Col
            xxl="12"
            xl="12"
            lg="12"
            md="12"
            xs="12"
            className="mb-1 mb-xxl-0 mt-1 mt-xxl-0"
          >
            <div className="d-flex align-items-center justify-content-between flex-wrap my-1">
            <span className="text-muted fs-14 fw-medium">
              Detailed overview of your past month finance under different
              financial ledger segments.
            </span>
            <p className="mb-0 fs-14 fw-medium text-muted">
            <i className="me-1 ri-time-line align-middle fs-14"></i>
            Updated on{" "}
            <span className="text-primary">
              {home_financeLedgerData?.as_on_date}
            </span>
          </p>
            </div>
          </Col>

          {/* <Col xxl="4" xl="6" lg="12" md="6" xs="12" className="mb-1 mb-xxl-0">
            <div className="d-flex align-items-center gap-2 justify-content-lg-end">
              <span
                className="text-dark fs-14 fw-medium"
                style={{ minWidth: "150px" }}
              >
                Select Month Range
              </span>
              <Input
                type="select"
                className="fs-12 fw-medium text-muted"
                style={{ cursor: "pointer", minWidth: "120px" }}
                onChange={handleFilterTime}
                value={selectedTime}
              >
                <option value="current-fy">Current F.Y.</option>
                <option value="last-month">Last Month</option>
                <option value="last-three-months">Last 3 Month</option>
                <option value="last-six-months">Last 6 Month</option>
              </Input>
            </div>
          </Col> */}
        </Row>
      </div>

      {home_financeLedgerLoading ? (
        <Home_Financial_Ledger_Skeleton />
      ) : (
        <Row className="">
           {Object.entries(home_financeLedgerData?.response || {}).map(([key, value]) => {
    // Create a display name from the key (customize if needed)
    let displayName = "";

    if (key === "cap_data") displayName = "Capital";
    else if (key === "fo_data") displayName = "F&O";
    else displayName = key.replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase());

            return (
              <React.Fragment key={key}>
                {/* Header card with the display name */}
                <Col xxl={4} xl={4} lg={12} md={12} sm={12} xs={12}>
                  <Card
                    className="finance_home_capital"
                    style={{
                      borderLeft: "2px solid #F1F4F7",
                      borderRight: "0",
                      borderTop: "0",
                      borderBottom: "0",
                    }}
                  >
                    <CardBody className="d-flex align-items-center">
                      <div>
                        <h3 className="text-dark m-0 mb-2">{displayName}</h3>
                        <p
                          className="fs-12 text-muted fw-semibold mb-1"
                          style={{ letterSpacing: "1px" }}
                        >
                          Financial Ledger
                        </p>
                      </div>
                    </CardBody>
                  </Card>
                </Col>

                {/* Debit card */}
                <Col xxl={4} xl={4} lg={6} md={6} sm={12} xs={12}>
                  <Card className="home_finance_card border-0">
                    <CardBody className="d-flex align-items-center">
                      <div>
                        <h4 className="text-dark m-0 mb-2 text-break">
                          <span className="fs-16 fw-medium text-muted me-2">
                            ₹
                          </span>
                          {parseFloat(value?.debit ?? "0.00").toLocaleString(
                            "en-IN" ,{
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                              }
                          )}
                        </h4>
                        <p
                          className="fs-12 text-muted fw-semibold mb-1"
                          style={{ letterSpacing: "1px" }}
                        >
                          DEBIT
                        </p>
                      </div>
                    </CardBody>
                  </Card>
                </Col>

                {/* Credit card */}
                <Col xxl={4} xl={4} lg={6} md={6} sm={12} xs={12}>
                  <Card className="home_finance_card border-0">
                    <CardBody className="d-flex align-items-center">
                      <div>
                        <h4 className="text-dark m-0 mb-2 text-break">
                          <span className="fs-16 fw-medium text-muted me-2">
                            ₹
                          </span>
                          {parseFloat(value?.credit ?? "0.00").toLocaleString(
                            "en-IN",{
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                              }
                          )}
                        </h4>
                        <p
                          className="fs-12 text-muted fw-semibold mb-1"
                          style={{ letterSpacing: "1px" }}
                        >
                          CREDIT
                        </p>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </React.Fragment>
            );
          })}
        </Row>
      )}
    </React.Fragment>
  );
};

export default Home_financial_ledger;
